import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'turso',
  name: 'Turso Database',
  category: 'database',
  description: 'Execute queries on Turso (libSQL) databases with automatic parameter binding',
  icon: 'siTurso',
  iconType: 'simple-icon',
  color: 'emerald',
  version: '1.0.0',
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  
  // Credentials configuration
  credentials: [
    {
      name: 'turso',
      required: true,
      displayName: 'Turso Credentials',
    },
  ],
  
  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'turso_database_query',
    description: 'Execute queries on Turso (libSQL) databases with automatic parameter binding',
    allowManualDescription: false,
    parameters: {
      operation: {
        toolParamName: 'operation',
        description: 'The database operation to perform: executeQuery, executeStatement, or batch',
        required: true,
        type: 'string',
      },
      query: {
        toolParamName: 'query',
        description: 'The SQL query to execute. Use ? for parameter placeholders.',
        required: false,
        type: 'string',
      },
      parameters: {
        toolParamName: 'parameters',
        description: 'Array of values for ? placeholders in the query',
        required: false,
        type: 'array',
      },
      returnFirst: {
        toolParamName: 'returnFirst',
        description: 'Return only the first result row (for executeQuery)',
        required: false,
        type: 'boolean',
      },
      queries: {
        toolParamName: 'queries',
        description: 'Array of query objects with sql and args properties (for batch operation)',
        required: false,
        type: 'array',
      },
    },
    outputMapping: {
      rows: 'The query result rows',
      rowCount: 'Number of rows returned or affected',
      columns: 'Column names from the result',
      lastInsertRowid: 'ID of the last inserted row (for INSERT statements)',
      firstRow: 'First row of results (convenience field)',
    },
  },
};

export default definition;
